import { ChangeDetectorRef, Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../environments/environment';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { ChatbotService } from './shareModule/component/chat/chatbot/chatbot.service';
import { LocalServiceService } from './shareModule/services/local-service.service';
import { SharedService } from './shareModule/services/shared.service';
import { MemberNotificationService } from './shareModule/services/member-notification.service';
@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket?: Socket | null;

  /**
   *  if disconnected let chatservice know and retry connection again and again
   *
   */

  constructor(
    private chatService: ChatbotService,
    private localService: LocalServiceService,
    private sharedService: SharedService,
    private notifService: MemberNotificationService
  ) {
    if (this.sharedService.isBrowser()) {
      let token = this.localService?.getUser()?.token;

      //Each time JWT changes due to login/logout we disconnect and try to reconnect    
      this.localService.authStateChange.subscribe(() => {
        if (this.localService?.getUser()?.token !== token) {
          //console.log('SocketService has detected login state has changed');
          this.chatService.chats.next([]);
          this.chatService.currentChatMessages.next([]);
          this.chatService.resetTotalUnreadCount();
          this.socket?.disconnect();
          token = this.localService?.getUser()?.token;
          this.init();
        }
      })
    }
  }

  public get isConnected(): boolean {
    return this.socket?.connected ?? false;
  }

  public connectionSubject = new BehaviorSubject<boolean>(false);
  public init() {
    let token = this.localService?.getUser()?.token;
    if (!token) {
      console.log('Socket has detected user has not loged in');
      return;
    }
    this.socket?.disconnect();

    console.log('Establiging socket connection...');
    this.socket = io( (environment as any).chatSocketServer, {
      reconnection: true,
      reconnectionDelayMax: 10_000,
      reconnectionDelay: 10_000,
      timeout: 10_000,
      extraHeaders: {
        authorization: `Bearer ${this.localService?.getUser()?.token}`,
      },
    });
    this.setupListeners();
    this.socket.connect();
    //console.log("socket to chat fetch ")
    // this.chatService.getAllChats();
    // this.chatService.getAfterMessages();
    this.chatService.updateTotalUnreadMessagesCount();
    // this.chatService.getBlockedList();
    // this.notifService.registerDevice();
    //this.notifService.getNotification();
  }

  public disconnect() {
    this.socket?.disconnect();
    this.socket = null;
  }
  private setupListeners() {
    const connectedEventHandler = () => {
      console.log('User connected to socket server');

      this.connectionSubject.next(true);
      // this.chatService.getAllChats();
      // this.chatService.updateTotalUnreadMessagesCount();
      // this.chatService.getBlockedList();
      this.notifService.registerDevice();
      // this.notifService.getNotification();
    };
    this.socket?.on('connect', connectedEventHandler);
    this.socket?.on('reconnect', connectedEventHandler);
    this.socket?.on('disconnect', () => {
      console.log('User disconencted from socket server');

      this.connectionSubject.next(false);
    });
    this.socket?.on('sent_message', () => {
      console.log('Send message accepted');
      this.chatService.getAfterMessages(true); //it fetchs sent message only now
      //this.chatService.getBlockedList();
      this.chatService.getAllChats(); //needed to reorder chats
    });
    this.socket?.on('new_message', () => {
      console.log('New message recieved');
      this.chatService.getAllChats();
      this.chatService.getBlockedList();
      this.chatService.getAfterMessages();
      this.chatService.updateTotalUnreadMessagesCount();
    });
    this.socket?.on('new_notif', () => {
      this.notifService.getNotification();
    });

    this.socket?.on('typing', (message) => {
      this.chatService.setTyping(message.userId);
    });
  }
}
